/**
 * Source unique des questions/réponses de la FAQ de la page d'accueil.
 * Utilisée à la fois par l'affichage (FaqV2) et par le JSON-LD FAQPage,
 * afin que les données structurées correspondent exactement au contenu visible.
 */
export const faqV2Items = [
  {
    question: "Quels sont vos services ?",
    answer:
      "Nous offrons un accompagnement complet en création de contenu vidéo et en stratégie de diffusion : vidéos verticales pour les réseaux sociaux, podcasts en studio ou en déplacement, captation d'événements, formations en ligne et publicités vidéo conçues pour la performance.",
  },
  {
    question: "Combien coûte un mandat avec l'Agence 8020 ?",
    answer:
      "Nos mandats sont adaptés à chaque client selon ses besoins, ses objectifs et la portée du projet. Nous travaillons principalement sous forme de forfaits mensuels qui incluent la stratégie, la création et la diffusion du contenu. Lors du premier appel, nous évaluons ensemble ce qui a le plus d'impact pour vous.",
  },
  {
    question: "Est-ce que vous faites seulement de la vidéo ?",
    answer:
      "La vidéo est au cœur de notre expertise, mais notre accompagnement va au-delà : structure de publication, positionnement de marque, idéation et optimisation pour les réseaux sociaux font partie de la stratégie de contenu complète.",
  },
  {
    question: "Peut-on tourner ailleurs qu'à votre studio ?",
    answer:
      "Oui. Nous disposons d'un studio professionnel à Mascouche, mais notre équipe se déplace partout au Québec pour capturer vos contenus dans votre environnement ou lors d'événements.",
  },
  {
    question: "Combien de temps prend un projet avant d'être diffusé ?",
    answer:
      "En général, une production complète, de la captation à la livraison, prend entre 7 et 14 jours ouvrables. Pour les clients en forfait mensuel, un calendrier clair de tournage et de diffusion est établi dès le départ.",
  },
  {
    question: "Faites-vous aussi de la publicité ?",
    answer:
      "Oui. En plus du contenu organique, nous produisons et diffusons des publicités vidéo sur Meta (Facebook et Instagram), YouTube et TikTok, de l'idéation jusqu'à l'optimisation des campagnes.",
  },
];
